<template>
  <div class="hyper-table" :class="show_footer ? 'with-footer' : ''">
    <div v-if="show_total" class="mb-4">
      {{ total_label }}:
      {{ total_records }}
    </div>
    <div class="d-flex" style="width: 100%; gap: 20px">
      <div
        class="form-group d-flex text-nowrap align-items-center mr-2"
        style="width: 50%"
        v-for="field in filter_fields"
      >
        <div>{{ field.label }}:</div>
        <dodelTypeahead
          :options="field_filter_options(field.key)"
          @hit="setFilter(field.key, $event)"
          @clear-selection="clearFilter(field.key)"
        />

        <!-- <select style="height: 34px;width: 100%;" class="form-control form-control-sm ml-2" v-model="filter[field.key]">
                    <option value="all-all-all">{{$t('message.comply_advantage.entity_type_all')}}</option>
                    <option v-for="option in field_filter_options(field.key)" :value="option">{{ option }}</option>
                </select> -->
      </div>
    </div>
    <div class="d-flex" style="width: 100%; gap: 20px">
      <div
        class="form-group d-flex text-nowrap align-items-center mr-2"
        style="width: 50%"
        v-if="client_companies_list && client_companies_list.length"
      >
        <div>Название компании клиента:</div>
        <dodelTypeahead
          :options="get_client_names_for_filter()"
          @hit="filter_out_values($event)"
          @clear-selection="clear_filter_value()"
        />
      </div>
    </div>
    <div class="d-flex">
      <div
        class="form-group d-flex text-nowrap align-items-center"
        v-if="show_filter_date"
      >
        <div>{{ $t("message.hypertable.date_since") }}:</div>
        <input
          type="date"
          style="height: 34px"
          class="form-control form-control-sm ml-2"
          v-model="datestart"
        />
      </div>
      <div
        class="form-group d-flex text-nowrap ml-2 align-items-center"
        v-if="show_filter_date"
      >
        <div>{{ $t("message.hypertable.date_till") }}:</div>
        <input
          type="date"
          style="height: 34px"
          class="form-control form-control-sm ml-2"
          v-model="dateend"
        />
      </div>
      <div
        class="form-group ml-2 d-flex gap-2 align-items-center"
        v-if="show_fast_date_selector"
      >
        {{ $t("message.hypertable.or") }}
        <button
          class="btn btn-outline-secondary btn-sm ml-2"
          v-b-modal.fast-date-selector
        >
          {{ $t("message.hypertable.monthly_report") }}
        </button>
      </div>
      <div class="form-group ml-auto">
        <div class="d-flex" style="gap: 10px">
          <button
            v-if="show_pdf"
            class="btn btn-outline-secondary btn-sm"
            :disabled="items.length == 0"
            @click.prevent="makePdf"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.0002 2C12.5525 2 13.0002 2.44772 13.0002 3L13.0002 12.5858L16.2931 9.29289C16.6837 8.90237 17.3168 8.90237 17.7074 9.29289C18.0979 9.68342 18.0979 10.3166 17.7074 10.7071L12.7074 15.7071C12.5198 15.8946 12.2655 16 12.0002 16C11.735 16 11.4807 15.8946 11.2931 15.7071L6.29314 10.7071C5.90261 10.3166 5.90261 9.68342 6.29314 9.29289C6.68366 8.90237 7.31683 8.90237 7.70735 9.29289L11.0002 12.5858L11.0002 3C11.0002 2.44772 11.448 2 12.0002 2ZM3.00024 14C3.55253 14 4.00024 14.4477 4.00024 15L4.00024 19C4.00024 19.2652 4.1056 19.5196 4.29314 19.7071C4.48067 19.8946 4.73503 20 5.00024 20L19.0002 20C19.2655 20 19.5198 19.8946 19.7073 19.7071C19.8949 19.5196 20.0002 19.2652 20.0002 19L20.0002 15C20.0002 14.4477 20.448 14 21.0002 14C21.5525 14 22.0002 14.4477 22.0002 15L22.0002 19C22.0002 19.7957 21.6842 20.5587 21.1216 21.1213C20.559 21.6839 19.7959 22 19.0002 22L5.00024 22C4.20459 22 3.44153 21.6839 2.87892 21.1213C2.31632 20.5587 2.00024 19.7957 2.00024 19L2.00024 15C2.00024 14.4477 2.44796 14 3.00024 14Z"
                fill="#333333"
              />
            </svg>
            PDF
          </button>
          <button
            class="btn btn-outline-secondary btn-sm"
            :disabled="items.length == 0 || is_exporting"
            @click.prevent="download_xlsx"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.0002 2C12.5525 2 13.0002 2.44772 13.0002 3L13.0002 12.5858L16.2931 9.29289C16.6837 8.90237 17.3168 8.90237 17.7074 9.29289C18.0979 9.68342 18.0979 10.3166 17.7074 10.7071L12.7074 15.7071C12.5198 15.8946 12.2655 16 12.0002 16C11.735 16 11.4807 15.8946 11.2931 15.7071L6.29314 10.7071C5.90261 10.3166 5.90261 9.68342 6.29314 9.29289C6.68366 8.90237 7.31683 8.90237 7.70735 9.29289L11.0002 12.5858L11.0002 3C11.0002 2.44772 11.448 2 12.0002 2ZM3.00024 14C3.55253 14 4.00024 14.4477 4.00024 15L4.00024 19C4.00024 19.2652 4.1056 19.5196 4.29314 19.7071C4.48067 19.8946 4.73503 20 5.00024 20L19.0002 20C19.2655 20 19.5198 19.8946 19.7073 19.7071C19.8949 19.5196 20.0002 19.2652 20.0002 19L20.0002 15C20.0002 14.4477 20.448 14 21.0002 14C21.5525 14 22.0002 14.4477 22.0002 15L22.0002 19C22.0002 19.7957 21.6842 20.5587 21.1216 21.1213C20.559 21.6839 19.7959 22 19.0002 22L5.00024 22C4.20459 22 3.44153 21.6839 2.87892 21.1213C2.31632 20.5587 2.00024 19.7957 2.00024 19L2.00024 15C2.00024 14.4477 2.44796 14 3.00024 14Z"
                fill="#333333"
              />
            </svg>
            Excel
          </button>
        </div>
      </div>
    </div>
    <div id="hyper-table-table">
      <div class="table-responsive" v-if="simulate_pagination">
        <b-table
          :items="filtered_items"
          :fields="fields"
          :per-page="per_page"
          :current-page="page"
          :foot-clone="show_footer"
          :class="{ 'clickable-table': clickable }"
          @row-clicked="rowClicked"
        >
          <template #cell(is_active)="data">
            <span v-html="data.value"></span>
          </template>
          <template #foot()="data" v-if="show_footer">
            <span>{{ tester(data) }}</span>
          </template>
        </b-table>
      </div>
      <div class="table-responsive" v-else>
        <b-table
          :items="filtered_items"
          :fields="fields"
          :foot-clone="show_footer"
          :class="{ 'clickable-table': clickable }"
          @row-clicked="rowClicked"
        >
          <template #foot()="data" v-if="show_footer">
            <span>{{ tester(data) }}</span>
          </template>
        </b-table>
      </div>
    </div>
    <div
      class="d-flex justify-content-between justify-space-between align-items-center"
    >
      <div v-if="pagination_through_total_count">
        <b-pagination
          v-if="totalRows / per_page > 1"
          v-model="page"
          :total-rows="totalRows"
          :per-page="per_page"
          @input="pageChanged($event, page)"
        ></b-pagination>
      </div>
      <div v-else>
        <b-pagination
          v-if="filtered_items.length / per_page > 1"
          v-model="page"
          :total-rows="filtered_items.length"
          :per-page="per_page"
        ></b-pagination>
      </div>

      <div class="align-items-center d-flex text-nowrap ml-auto">
        <label for="per_page"
          >{{ $t("message.hypertable.records_per_page") }}:</label
        >
        <select
          v-model="per_page"
          id="per_page"
          class="form-control form-control-sm ml-3"
        >
          <option value="10">10</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
      </div>
    </div>
    <b-modal
      id="fast-date-selector"
      size="md"
      :title="$t('message.hypertable.choose_month')"
      :hide-footer="true"
    >
      <div class="form-group">
        <label for="year">{{ $t("message.hypertable.year") }}</label>
        <select id="year" v-model="fast_period_year" class="form-control">
          <option v-for="year in years" :value="year">
            {{ year }}
          </option>
        </select>
      </div>
      <div class="form-group" v-if="fast_period_year != ''">
        <label for="month">{{ $t("message.hypertable.month") }}</label>
        <select id="month" v-model="fast_period_month" class="form-control">
          <option v-for="month in months" :value="month">
            {{ month }}
          </option>
        </select>
      </div>
      <div class="" v-if="fast_period_year != '' && fast_period_month != ''">
        <button class="btn btn-primary ml-auto" @click="showFastReport">
          {{ $t("message.hypertable.show_report") }}
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import dodelTypeahead from "./fields/dodel-typeahead.vue";
var pdfMake = require("pdfmake/build/pdfmake");
var pdfFonts = require("pdfmake/build/vfs_fonts");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
  cn: {
    normal: "https://attis-trade.ru/fonts/NotoSansSC-Regular.ttf",
    bold: "https://attis-trade.ru/fonts/NotoSansSC-Regular.ttf",
    italics: "https://attis-trade.ru/fonts/NotoSansSC-Regular.ttf",
    bolditalics: "https://attis-trade.ru/fonts/NotoSansSC-Regular.ttf",
  },

  // download default Roboto font from cdnjs.com
  Roboto: {
    normal:
      "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf",
    bold: "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf",
    italics:
      "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf",
    bolditalics:
      "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf",
  },
};

var htmlToPdfmake = require("html-to-pdfmake");
import moment from "moment";
export default {
  components: {
    dodelTypeahead,
  },
  props: {
    request: {
      type: String,
    },
    additional_params: {
      type: String,
      default: "",
    },
    client_companies_list: {
      type: Array,
    },
    fields: {
      type: Array,
    },
    pagination_through_total_count: {
      type: Boolean,
      default: false,
    },
    simulate_pagination: {
      type: Boolean,
      default: false,
    },
    show_total: {
      type: Boolean,
      default: false,
    },
    total_label: {
      type: String,
      default: "",
    },
    show_footer: {
      type: Boolean,
      default: false,
    },
    show_fast_date_selector: {
      type: Boolean,
      default: false,
    },    
    show_filter_date: {
      type: Boolean,
      default: true,
    },
    filter_date_empty_on_init: {
      type: Boolean,
      default: false,
    },
    show_pdf: {
      type: Boolean,
      default: true,
    },
    excel_request: {
      type: String,
      default: "",
    },
    clickable: {
      type: Boolean,
      default: false,
    }
  },
  watch: {
    per_page() {
      this.page = 1;
      if (!this.simulate_pagination && this.is_mounted) this.load();
    },
    // page(){
    //     if(!this.simulate_pagination && this.is_mounted)
    //         this.load()
    // },
    dateend() {
      if (this.is_mounted) this.load();
    },
    datestart() {
      if (this.is_mounted) this.load();
    },
    // filter: {
    //     deep: true,
    //     handler(){
    //         this.page = 0
    //     }
    // }
  },
  computed: {
    months() {
      let months = [];
      let date = new Date();
      let month_names = [
        this.$t("message.hypertable.month_0"),
        this.$t("message.hypertable.month_1"),
        this.$t("message.hypertable.month_2"),
        this.$t("message.hypertable.month_3"),
        this.$t("message.hypertable.month_4"),
        this.$t("message.hypertable.month_5"),
        this.$t("message.hypertable.month_6"),
        this.$t("message.hypertable.month_7"),
        this.$t("message.hypertable.month_8"),
        this.$t("message.hypertable.month_9"),
        this.$t("message.hypertable.month_10"),
        this.$t("message.hypertable.month_11"),
      ];
      if (this.fast_period_year == date.getFullYear()) {
        let current_month = date.getMonth();
        for (let i = 0; i <= current_month; i++) {
          months.push(month_names[i]);
        }
        //short list
      } else {
        for (let i = 0; i < 12; i++) {
          months.push(month_names[i]);
        }
      }
      return months;
    },
    years() {
      let years = [];
      let date = new Date();
      for (let i = date.getFullYear(); i > date.getFullYear() - 4; i--) {
        years.push(i);
      }
      return years;
    },
    total_records() {
      return this.items.length;
    },
    filter_fields() {
      return this.fields.filter((item) => item.filterable == true);
    },
    filtered_items() {
      if (Object.keys(this.filter).length == 0) {
        return this.items;
      }
      return this.items.filter((item) => {
        let result = 0;
        for (let fil of Object.keys(this.filter)) {
          if (this.filter[fil] !== "") {
            if (item[fil] == this.filter[fil]) {
              result++;
            }
          } else {
            result++;
          }
        }
        return result == Object.keys(this.filter).length;
      });
    },
  },
  methods: {
    clearFilter(field) {
      this.$delete(this.filter, field);

      this.page = 1;
      this.load();
    },
    setFilter(field, data) {
      this.$set(this.filter, field, data);

      this.page = 1;
      this.load();
    },
    pageChanged(evt, page) {
      console.log(evt, page);
      this.load(page);
    },
    is_privileged(data) {
      return "132";
    },
    tester(data) {
      if (data.field.summable === true) {
        if (data.field.formatter)
          return data.field.formatter(
            this.sumCol(data.column),
            data.column,
            data,
          );
        else return this.sumCol(data.column);
      } else {
        return "";
      }
      console.log(data);
      return 123;
    },
    showFastReport() {
      this.$bvModal.hide("fast-date-selector");
      this.datestart = moment()
        .set({
          year: this.fast_period_year,
          month: this.fast_period_month,
          date: "1",
        })
        .format("YYYY-MM-DD");
      this.dateend = moment()
        .set({
          year: this.fast_period_year,
          month: this.fast_period_month,
          date: "1",
        })
        .endOf("month")
        .format("YYYY-MM-DD");
    },
    field_filter_options(field) {
      var fieldDefinition = this.fields.find(
        (item) => item.key === field
      );

      if (fieldDefinition && fieldDefinition.filter_options) {
        return fieldDefinition.filter_options;
      }

      var filteredItems = [
        ...new Set(this.filtered_items.map((item) => item[field]))
      ];

      if (
        filteredItems.length == 1 &&
        field == "company_name" &&
        filteredItems[0]
      ) {
        this.companyName = filteredItems[0];
      } else {
        this.companyName = "";
      }

      return filteredItems;
    },
    get_client_names_for_filter() {
      return this.client_companies_list.map(x => x.value);
    },
    filter_out_values(value) {
      var foundValue = this.client_companies_list.find(x => x.value === value);
      if (foundValue) {
        this.client_company_to_filter = foundValue.key;
      } else {
        this.client_company_to_filter = '';
      }
      this.reload_list();
    },
    clear_filter_value() {
      this.client_company_to_filter = '';
      this.reload_list();
    },
    reload_list() {
      if (this.page === 1) {
        this.load();
      } else {
        this.page = 1;
      }
    },
    download_xlsx() {
      this.is_exporting = true;

      if (this.excel_request) {
        axios.get(`${window.base}${this.excel_request}?datestart=${this.datestart}&dateend=${this.dateend}&companyId=${this.client_company_to_filter}`, {
          responseType: 'blob'
        })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Журнал_запросų_API.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setTimeout(() => window.URL.revokeObjectURL(url), 1000);
          })
          .catch((error) => {
            console.error("Download failed:", error);
          })
          .finally(() => {
            this.is_exporting = false;
          });

      } else {
        let per_page = this.per_page;
        this.per_page = 100000;
        const waitForTable = (previousRowCount = 0, stableChecks = 0) => {
          const table = document.querySelector("#hyper-table-table table");
          if (!table) {
            setTimeout(() => waitForTable(previousRowCount, stableChecks), 100);
            return;
          }
          const rowCount = table.querySelectorAll("tbody tr").length;
          if (rowCount === previousRowCount) {
            stableChecks++;
          } else {
            stableChecks = 0;
          }
          if (stableChecks < 3) {
            setTimeout(() => waitForTable(rowCount, stableChecks), 100);
            return;
          }
          try {
            var uri = "data:application/vnd.ms-excel;base64,",
              template =
                '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
              base64 = function (s) {
                return window.btoa(unescape(encodeURIComponent(s)));
              },
              format = function (s, c) {
                return s.replace(/{(\w+)}/g, function (m, p) {
                  return c[p];
                });
              };
            let dateend = moment(this.dateend).format("DD.MM.YYYY");
            let datestart = moment(this.datestart).format("DD.MM.YYYY");
            var toExcel = table
              .innerHTML
              .replaceAll(
                '<span class="sr-only"> (Click to sort Ascending)</span>',
                "",
              )
              .replaceAll("₽", "")
              .replaceAll("&#8381;", "")
              .replaceAll("&#x20BD;", "")
              .replaceAll("&nbsp;", "");
            console.log("Exporting rows:", rowCount);

            toExcel =
              "<div>За период: " + datestart + "-" + dateend + "</div>" + toExcel;
            var ctx = {
              worksheet: name || "",
              table: toExcel,
            };
            var link = document.createElement("a");
            link.download = "users-history.xls";
            link.href = uri + base64(format(template, ctx));
            link.click();
          } catch (error) {
            console.error("Excel export failed:", error);
          } finally {
            this.per_page = per_page;
            this.is_exporting = false;
          }
        };
        this.$nextTick(() => {
          waitForTable();
        });
      }
    },
    async makePdf() {
      let per_page = this.per_page;
      this.per_page = 100000;
      setTimeout(async () => {
        var element = document
          .getElementById("hyper-table-table")
          .cloneNode(true);

        let images = element.querySelectorAll("img");
        await element.querySelectorAll(".table-responsive").forEach((res) => {
          res.classList.remove("table-responsive");
        });
        await element.querySelectorAll("table").forEach((res) => {
          res.style.breakWord = "break-all";
          res.style.fontSize = "12px";
        });
        await images.forEach(async (image) => {
          if (image.src == "" || image.src == null) {
            console.log("tainted");
            image.remove();
          } else {
            let downloadedImg = new Image();
            downloadedImg.crossOrigin = "Anonymous";
            await downloadedImg.addEventListener(
              "load",
              (di) => {
                let canvas = document.createElement("canvas");
                canvas.width = downloadedImg.width;
                canvas.height = downloadedImg.height;
                let ctx = canvas.getContext("2d");
                ctx.drawImage(downloadedImg, 0, 0);
                let data = canvas.toDataURL("image/jpeg");
                console.log(data);
                image.alt = data;
                image.src = data;
              },
              false,
            );
            downloadedImg.src = image.src;
          }
        });
        let dateend = moment(this.dateend).format("DD.MM.YYYY");
        let datestart = moment(this.datestart).format("DD.MM.YYYY");
        let toPDF = element.innerHTML.replaceAll(
          '<span class="sr-only"> (Click to sort Ascending)</span>',
          "",
        );
        toPDF =
          "<div>За период: " + datestart + "-" + dateend + "</div>" + toPDF;
        setTimeout(() => {
          let dom = htmlToPdfmake(toPDF, {
            tableAutoSize: true,
            ignoreStyles: ["font-family", "width"],
          });
          var dd = {
            content: dom,
            pageOrientation: "landscape",
          };
          pdfMake.createPdf(dd).download("report.pdf");
          this.per_page = per_page;
        }, 2000);
      }, 100);
    },
    sumCol(key) {
      let sum = 0;
      this.items.forEach((item) => {
        sum += parseFloat(item[key]);
      });
      return sum;
    },
    load(page = false) {
      // this.filter = {};
      // this.page = 0
      let date = "";
      if (this.show_filter_date)
        date = "&datestart=" + this.datestart + "&dateend=" + this.dateend;

      let url =
        window.base +
        this.request +
        "?page=" +
        (this.page - 1) +
        "&pageSize=" +
        this.per_page +
        date;

      if (page !== false)
        url =
          window.base +
          this.request +
          "?page=" +
          (page - 1) +
          "&pageSize=" +
          this.per_page +
          date;
      if (this.simulate_pagination)
        url =
          window.base +
          this.request +
          "?page=0&pageSize=1000000&datestart=" +
          this.datestart +
          "&dateend=" +
          this.dateend;
      if (this.client_companies_list && this.client_companies_list.length) {
        url += "&companyId=" + this.client_company_to_filter;
      }
      
      if (this.additional_params) {
        url += this.additional_params;
      }

      Object.keys(this.filter).forEach((field) => {
        if (this.filter[field] !== "") {
          url +=
            "&" +
            encodeURIComponent(field) +
            "=" +
            encodeURIComponent(this.filter[field]);
        }
      });

      axios.get(url).then((response) => {
        this.items = response.data;
        if (this.pagination_through_total_count) {
          if (this.items && this.items.length) {
            this.totalRows = this.items[0].total_count;
          } else {
            this.totalRows = 0;
          }
        }
        else this.totalRows = this.items.length;
        let foot = {};
        // if(this.show_footer){
        //     this.fields.forEach(item=>{
        //         if(item.summable===true){
        //             foot[item['key']]=this.sumCol(item['key'])
        //         }else{
        //             foot[item['key']]=''
        //         }
        //     })
        //     this.items.push(foot)
        // }
      });
    },
    rowClicked(item) {
      this.$emit("row-clicked", item);
    },
  },
  data() {
    return {
      items: [],
      filter: {},
      per_page: 10,
      page: 1,
      datestart: "2023-04-01",
      dateend: "2023-04-21",

      fast_period_year: "",
      fast_period_month: "",

      totalRows: 0,

      is_mounted: false,
      client_company_to_filter: '',
      is_exporting: false,
    };
  },
  mounted() {
    let d = new Date();
    if (!this.filter_date_empty_on_init) {
      this.dateend = moment().add(1, "day").format("Y-MM-DD");
      this.datestart = moment().subtract(1, "month").format("Y-MM-DD");
    } else {
      this.dateend = "";
      this.datestart = "";
    }
    setTimeout(() => {
      this.is_mounted = true;
      this.load();
    }, 100);
  },
};
</script>
<style>
/* .hyper-table.with-footer table tr:last-child td{
        font-weight: bold;
    }
    .hyper-table.with-footer table tr:last-child td:first-child:before{
        content: "Всего:";
    } */
.hyper-table.with-footer table tfoot tr th:first-child span:before {
  content: "Всего:";
}
.hyper-table.with-footer table tfoot tr th {
  background: none !important;
}
.b-pagination .page-item.disabled {
  display: none;
}

.clickable-table tbody tr {
  cursor: pointer;
  transition: background-color 0.15s ease, box-shadow 0.15s ease;
}

.clickable-table tbody tr:hover {
  background-color: #f5f5f5;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}
</style>
